export enum AccessAction {
  None,
  Buy,
  Rent,
  BuyOrRent,
  Subscribe,
  PricingPlan,
  SignIn,
}
